import React, {useContext, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import {green, red} from "@mui/material/colors";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MedicationIcon from "@mui/icons-material/Medication";
import {useMutationDeleteCart} from "../../../queries/product/hooks/useMutationDeleteCart";
import {NotificationType} from "../../../constants/global";
import {ToasterContext} from "../Toaster/ToasterContext";
import {CART} from "../../../queries/product/productTypeDefs";
import {UserContext} from "../../../hooks/userContext";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import {InputBase} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Paper from "@mui/material/Paper";
import {useMutationUpdateCart} from "../../../queries/product/hooks/useMutationUpdateCart";
import axios from "axios";

interface IShoppingCartItemProps {
  cartItem: any
}

export const ShoppingCartItem:React.FunctionComponent<IShoppingCartItemProps> = ({
  cartItem
}) => {


  const { id }: any = useContext(UserContext);
  const {addToast} = useContext(ToasterContext);
  const [packageAvailable, setPackageAvailable] = useState<number>(cartItem.quantity);
  const [deleteCart, { loading }] = useMutationDeleteCart({
    refetchQueries: [
      {
        query: CART,
        variables: {
          where: { userId: { equals: +id } },
          orderBy: { createdAt: 'asc' }
        },
        awaitRefetchQueries: true,
      },
    ],
  });
  const [updateCart, { loading: updateCartLoading }] = useMutationUpdateCart();
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!cartItem) {
      return
    }
    const ndc = cartItem.item.ndc;
    const formattedNdc = ndc.replace(/-/g, '');
    const imageUrlApi = `${process.env.REACT_APP_API_URL}/drug-images?ndc=${formattedNdc}`;
    axios.get(imageUrlApi)
      .then((response) => {
        setImageUrl(response.data.imageUrl);
      })
      .catch((error) => {
        console.error("Error fetching drug image:", error);
      })

  }, [cartItem]);

  const deleteCartItem = (item: any) => {
    if (!loading) {
      deleteCart({variables: { where: { id: item.id } }}).catch((error: any) => {
        addToast({ type: NotificationType.Error, title: error.message  });
      });
    }
  }

  const handleChangePackageAvailable = (isPlus: boolean = true) => {
    const requestData = {
      User: {
        connect: {
          id: +id
        }
      },
      Product: {
        connect: {
          id: cartItem.item.id
        }
      },
    };

    if (isPlus) {
      updateCart({ variables: { data: {...requestData, quantity: { increment: 1 } }, where: { id: cartItem.id } } }).then((res: any) => {
        setPackageAvailable(res.data.updateCart.quantity);
      }).catch((error: any) => {
        addToast({ type: NotificationType.Error, title: error.message  });
      });
    } else {
      updateCart({ variables: { data: {...requestData, quantity: { decrement: 1 } }, where: { id: cartItem.id } } }).then((res: any) => {
        setPackageAvailable(res.data.updateCart.quantity);
      }).catch((error: any) => {
        addToast({ type: NotificationType.Error, title: error.message  });
      });
    }
  }

  const getPrice = () => {
    const price = Number(cartItem.item.price.replace(/[^0-9.-]+/g,""));

    return price * packageAvailable;
  }

  return (
    <React.Fragment>
      <Box sx={{ p: 2}}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {imageUrl ? (
              <img src={imageUrl} alt="Drug" style={{ width: 30, height: 30, borderRadius: '4px', marginRight: '8px' }} />
            ) : (
              <MedicationIcon sx={{ color: green[500] }} />
            )}
            <Box sx={{maxWidth: 180, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>
              {cartItem.item.drugName}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            $ {getPrice().toFixed(2)}
            <DeleteOutlineOutlinedIcon sx={{ ml: 2, p: 0, cursor: 'pointer', color: red[500] }} onClick={() => deleteCartItem(cartItem) } />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2}}>
          <Paper sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 100, height: 32 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <IconButton
                size='small'
                color="primary"
                sx={{ p: 0 }}
                onClick={() => handleChangePackageAvailable(false)}
                disabled={packageAvailable === 1 || updateCartLoading}
              >
                <RemoveIcon fontSize='small' />
              </IconButton>
              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <InputBase
                sx={{ flex: 1, input: {textAlign: "center"} }}
                value={packageAvailable}
              />
              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <IconButton
                size='small'
                color="primary"
                sx={{ p: 0 }}
                onClick={() => handleChangePackageAvailable()}
                disabled={packageAvailable === cartItem.item.quantity || updateCartLoading}
              >
                <AddIcon fontSize='small' />
              </IconButton>
            </Box>
          </Paper>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            available: {cartItem.item.quantity}
          </Box>
        </Box>
      </Box>
      <Divider />
    </React.Fragment>
  )
}

export default ShoppingCartItem;

